/* Risk Tolerance Quiz — Ch. 9. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  var QUESTIONS = [
    { q: 'Your investments drop 40% in 6 months. What do you do?',
      opts: [{ t: 'Sell — get out before it gets worse', s: 0 },
             { t: 'Hold — markets recover',                s: 7 },
             { t: 'Buy more — it’s on sale',               s: 10 }] },
    { q: 'How long can you leave money invested without needing it?',
      opts: [{ t: 'Less than 1 year', s: 0 }, { t: '1–5 years', s: 4 }, { t: '5–15 years', s: 7 }, { t: '15+ years', s: 10 }] },
    { q: 'Pick a portfolio for 10 years:',
      opts: [{ t: 'Likely $11k, never below $10k', s: 1 },
             { t: 'Likely $14k, low $9k',           s: 5 },
             { t: 'Likely $20k, low $7k',           s: 8 },
             { t: 'Likely $30k, low $5k',           s: 10 }] },
    { q: 'What does “risk” mean to you?',
      opts: [{ t: 'Losing money',                   s: 0 },
             { t: 'Underperforming the market',     s: 6 },
             { t: 'Not taking enough chances',      s: 10 }] },
    { q: 'Markets crash 30%. Headlines panic. You:',
      opts: [{ t: 'Move everything to cash',        s: 0 },
             { t: 'Stop checking, keep auto-buying',s: 8 },
             { t: 'Buy more, keep auto-buying',     s: 10 }] },
    { q: 'Which goal matters more?',
      opts: [{ t: 'Protect what I have',            s: 1 },
             { t: 'Steady growth',                  s: 5 },
             { t: 'Maximum long-term growth',       s: 10 }] },
    { q: 'If your portfolio grew 25% in a year, you would:',
      opts: [{ t: 'Sell some — lock in profits',    s: 2 },
             { t: 'Rebalance to original mix',      s: 6 },
             { t: 'Leave it — let winners run',     s: 9 }] },
    { q: 'Honest assessment of your investing knowledge:',
      opts: [{ t: 'I’m new to it',                  s: 3 },
             { t: 'I know the basics',              s: 6 },
             { t: 'Pretty solid',                   s: 9 }] },
    { q: 'A friend triples their money on a tip. You:',
      opts: [{ t: 'Try it next time',               s: 9 },
             { t: 'Note the lucky outcome',         s: 5 },
             { t: 'Keep my plan',                   s: 7 }] },
    { q: 'How important is sleeping well at night vs. maximum return?',
      opts: [{ t: 'Sleep is more important',        s: 2 },
             { t: 'Both matter equally',            s: 6 },
             { t: 'I want max return',              s: 10 }] }
  ];

  var PROFILES = [
    { name: 'Capital Preservation', cut: 30, alloc: { stocks: 20, bonds: 70, cash: 10 }, ret: '3–5%/yr',
      desc: 'You prioritise not losing money. Stick to high-yield savings, short-duration bonds, and a small allocation to a broad index for inflation protection.' },
    { name: 'Balanced Growth',      cut: 60, alloc: { stocks: 60, bonds: 35, cash: 5 },  ret: '5–7%/yr',
      desc: 'Classic 60/40. Steady, diversified, and historically robust through most downturns.' },
    { name: 'Growth',               cut: 85, alloc: { stocks: 85, bonds: 12, cash: 3 },  ret: '7–9%/yr',
      desc: 'Heavy on stocks. You can stomach drawdowns and have time to recover.' },
    { name: 'Maximum Growth',       cut: 100, alloc: { stocks: 100, bonds: 0, cash: 0 }, ret: '8–10%/yr',
      desc: '100% stocks, all index. Highest expected return, biggest swings. Only if you can keep buying through a 50% drop without flinching.' }
  ];

  class RiskQuiz {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.answers = u.a ? u.a.split(',').map(Number) : [];
      this.idx = this.answers.length;
      this.render();
    }
    render() {
      if (this.idx >= QUESTIONS.length) return this.renderResult();
      var q = QUESTIONS[this.idx];
      var pct = (this.idx / QUESTIONS.length) * 100;
      this.el.innerHTML = `
        <div class="sim-quiz">
          <div class="sim-quiz__progress"><div class="sim-quiz__progress-bar" style="width:${pct}%"></div></div>
          <p class="label">QUESTION ${this.idx + 1} OF ${QUESTIONS.length}</p>
          <h3 class="sim-quiz__q">${q.q}</h3>
          <div class="sim-quiz__opts">
            ${q.opts.map((o, i) => `<button class="sim-quiz__opt" data-pick="${i}">${o.t}</button>`).join('')}
          </div>
        </div>`;
      this.el.querySelectorAll('[data-pick]').forEach(b => {
        b.addEventListener('click', () => {
          this.answers[this.idx] = q.opts[+b.dataset.pick].s;
          this.idx++;
          IT.url.write({ a: this.answers.join(',') });
          this.render();
        });
      });
    }
    renderResult() {
      var max = QUESTIONS.reduce((sum, q) => sum + Math.max.apply(null, q.opts.map(o => o.s)), 0);
      var got = this.answers.reduce((a, b) => a + b, 0);
      var pct = (got / max) * 100;
      var p = PROFILES.find(p => pct <= p.cut) || PROFILES[3];
      // Compound projection: $1k/mo for 30 yrs at midpoint expected return
      var midRet = p.cut === 30 ? 0.04 : p.cut === 60 ? 0.06 : p.cut === 85 ? 0.08 : 0.09;
      var monthlyR = midRet / 12, n = 360;
      var fv = 1000 * ((Math.pow(1 + monthlyR, n) - 1) / monthlyR);
      this.el.innerHTML = `
        <div class="sim-results" style="text-align:center; max-width:540px; margin:0 auto;">
          <span class="pill">YOUR PROFILE</span>
          <h2 style="margin:8px 0;">${p.name}</h2>
          <p style="color:var(--ink-mid);">${p.desc}</p>
          <div class="sim-chart-wrap" style="min-height:240px; margin: 16px 0;"><canvas id="rq-chart"></canvas></div>
          <p class="label">EXPECTED RETURN</p>
          <p style="font-family:var(--font-display); font-weight:900; font-size:32px; margin:0 0 16px; color:var(--yellow);">${p.ret}</p>
          <div class="sim-insight">$1,000/month for 30 years at this profile’s mid-return: <strong>${fmt(fv)}</strong>.</div>
          <div style="display:flex; gap:10px; flex-wrap:wrap; justify-content:center; margin-top:16px;">
            <a class="btn btn--primary" href="/pages/simulators-compound-interest?p=0&m=1000&r=${(midRet*100).toFixed(1)}&y=30">Try the compound calculator with these returns →</a>
            <button class="btn btn--outline" data-restart>Retake quiz</button>
          </div>
        </div>`;
      this.el.querySelector('[data-restart]').addEventListener('click', () => {
        this.answers = []; this.idx = 0;
        IT.url.write({ a: '' }); this.render();
      });
      this.drawAlloc(p.alloc);
    }
    drawAlloc(a) {
      if (!window.Chart) { setTimeout(() => this.drawAlloc(a), 200); return; }
      var T = window.IT_TOKENS;
      new Chart(this.el.querySelector('#rq-chart'), {
        type: 'doughnut',
        data: {
          labels: ['Stocks', 'Bonds', 'Cash'],
          datasets: [{
            data: [a.stocks, a.bonds, a.cash],
            backgroundColor: [T.yellow, T.blue, T.textMuted],
            borderWidth: 1, borderColor: T.bgCard
          }]
        },
        options: { responsive: true, maintainAspectRatio: false, cutout: '65%' }
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new RiskQuiz('simulator-container'));
})();
